import { render, staticRenderFns } from "./StepTrustSelection.vue?vue&type=template&id=978e7ece&"
import script from "./StepTrustSelection.vue?vue&type=script&lang=js&"
export * from "./StepTrustSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports